
import {defineComponent, ref, onMounted, computed, watch, reactive} from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import AddUserModal from "@/components/modals/forms/AddUserModal.vue";
import DeleteModal from "@/components/modals/forms/DeleteModal.vue";
import { MenuComponent } from "@/assets/ts/components";
import {User} from "@/store/modules/ApiModule";
import {useStore} from "vuex";
import {Actions} from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "users-listing",
  components: {
    Datatable,
    AddUserModal,
    DeleteModal
  },
  setup() {
    const tableHeader = ref([
      {
        name: "Name",
        key: "name",
        sortable: true,
      },
      {
        name: "Email",
        key: "email",
        sortable: true,
      },
      {
        name: "Role",
        key: "role",
        sortable: true,
      },
      {
        name: "Actions",
        key: "actions",
      },
    ]);

    const store = useStore();
    let myUsers = ref<Array<User>>([]);
    let selectedItem = reactive({} as User);

    const setSelectedItem = (item) => {
      if(item == null){
        Object.assign(selectedItem, {
          id: 0, name: "", email: "", password: "", role: "", token:""
        });
      }
      else {
        Object.assign(selectedItem, item);
      }
    }

    let myData = computed(() => {
      return store.state.api.users;
    });

    onMounted(() => {
      MenuComponent.reinitialization();
      store.dispatch(Actions.LOAD_USERS);
    });

    watch(myData, (newValue, oldValue) => {
      myUsers.value.splice(0,myUsers.value.length)
      newValue.forEach(function (value) {
        myUsers.value.push(value);
      });
    });

    const search = ref<string>("");
    const searchItems = () => {
      /*tableData.value.splice(0, tableData.value.length, ...initClients.value);
      if (search.value !== "") {
        let results: Array<Client> = [];
        for (let j = 0; j < tableData.value.length; j++) {
          if (searchingFunc(tableData.value[j], search.value)) {
            results.push(tableData.value[j]);
          }
        }
        tableData.value.splice(0, tableData.value.length, ...results);
      }*/
    };

    const searchingFunc = (obj, value): boolean => {
      for (let key in obj) {
        if (!Number.isInteger(obj[key]) && !(typeof obj[key] === "object")) {
          if (obj[key].indexOf(value) != -1) {
            return true;
          }
        }
      }
      return false;
    };

    return {
      myData,
      myUsers,
      selectedItem,
      setSelectedItem,
      tableHeader,
      search,
      searchItems,
    };
  },
});
